module.exports = __webpack_public_path__ + "static/img/ic_middle@2x.3288949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_middle@2x.png
// module id = fVSX
// module chunks = 1